<common-header title="{{ title }}" [items]="items"></common-header>

<app-session-cashout [turnId]="idTurn"></app-session-cashout>
